import _defineProperty from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { render } from "vue";
import { transZhCnElemenComponent } from './utils/elemen-ui-utils';
export class BaseController {
  /**
   * 构造搜索表单
   * @param el 挂载节点
   * @param component 组件
   * @param config 属性配置
   */
  constructor(el, component, config) {
    /**
     * 组件事件集合
     * @memberof FormDialog
     */
    _defineProperty(this, "handler", new Proxy({}, {}));
    /**
     * 控制器
     * @memberof FormDialog
     */
    _defineProperty(this, "controller", null);
    /**
     * 获取表单实例
     * @param searchFormController 表单实例
     */
    _defineProperty(this, "_getInstance", controller => {
      this.controller = controller;
    });
    render(h(transZhCnElemenComponent(component), {
      getInstance: this._getInstance,
      handler: this.handler,
      ...config
    }), el);
  }
}